import styled from "styled-components";
import { motion } from "framer-motion";

export const StyledMotionDiv = styled(motion.div)`
  background-color: #F5F5F5;
`;

export const PdfTitle = styled.div`
  text-align: center;
`;

export const PdfPreview = styled.div`
  background: #EEE;
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  border-radius: 16px 16px 0px 0px;
`;

export const PdfDownload = styled.div`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  padding: 10px 0;

  a {
    color: var(--Neutral-Gray-900, #1B1B19);
    font-weight: bold;
  }
`
export const PdfPreviewContainer = styled.div`
  padding-bottom: 48px;
`